import { apiUTCToLocalDateTime } from "@jugl-web/utils";
import format from "date-fns/format";
import isThisYear from "date-fns/isThisYear";
import { useMemo } from "react";

export const CRMInfoMessage: React.FC<{
  message: string;
  timestamp: string;
  isBlocked?: boolean;
}> = ({ message, timestamp, isBlocked }) => {
  const localDate = useMemo(
    () => apiUTCToLocalDateTime(timestamp),
    [timestamp]
  );

  return (
    <div className="flex flex-col items-center justify-center bg-[#EEF2F5] pt-[6px] text-center">
      <span className="font-secondary text-[13px] font-medium leading-[150%] text-[#828282]">
        {isBlocked ? `${message} 🚫` : message}
      </span>
      <span className="text-dark-700 font-secondary text-xs leading-[140%]">
        {format(
          localDate,
          isThisYear(localDate) ? "d MMM, h:mm a" : "d MMM yyyy, h:mm a"
        )}
      </span>
    </div>
  );
};
